import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import Login from '@/components/Login.vue'
import Register from '@/components/Register.vue'
import SclUserLogin from '@/components/SclUserLogin.vue'
import Forget from '@/components/Forget.vue'
import Vip from '@/components/Vip.vue'
import Identity from '@/components/Identity.vue'
import Activation from '@/components/Activation.vue'
import Information from '@/components/Information.vue'
import Save from '@/components/Save.vue'
import UpdateUserName from '@/components/UpdateUserName.vue'
import CompareSchool from '@/components/CompareSchool.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import News from '@/components/News.vue'
import Province from '@/components/Province.vue'
import WechatPay from '@/components/WechatPay.vue'
import SchoolRank from '@/components/SchoolRank.vue'
import OccupationRank from '@/components/OccupationRank.vue'
import './assets/css/resetElement.scss'
import GeminiScrollbar from 'vue-gemini-scrollbar'
import '@/assets/js/gt.js'
import { getQuery, setToken } from '@/utils/auth'
import htmlToPdf from '@/utils/html_to_pdf'

// import Cookies from 'js-cookie'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(GeminiScrollbar)
Vue.use(htmlToPdf)

Vue.component("Login", Login);
Vue.component("SclUserLogin", SclUserLogin);
Vue.component("Register", Register);
Vue.component("Forget", Forget);
Vue.component("Vip", Vip);
Vue.component("Identity", Identity);
Vue.component("Activation", Activation);
Vue.component("Information", Information);
Vue.component("Save", Save);
Vue.component("UpdateUserName", UpdateUserName);
Vue.component("Breadcrumb", Breadcrumb);
Vue.component("News", News);
Vue.component("CompareSchool", CompareSchool);
Vue.component("Province", Province);
Vue.component("WechatPay", WechatPay);
Vue.component("SchoolRank", SchoolRank);
Vue.component("OccupationRank", OccupationRank);

// router.beforeEach((to, from, next) => {
//   // if (Cookies.getItem("mobile")) {
//   //   next()
//   // } else {
//     if (to.path === '/evaluationDetail') {
//       next()
//     }
//   // }
//   // store.dispatch('user/CLEAR_CANCEL');
//   next();
// });

Vue.directive('clickWithAuthLogin', {
  bind: function (el, binding, vnode) {
    const _this = this;
    el.onclick = function (event) {
      event.stopPropagation();
      //监听点击事件，判断是否登录
      if (!store.state.user.token) {
        event.preventDefault();
        el.blur();
        localStorage.removeItem("mobile");
        localStorage.removeItem("gkInforObj");
        localStorage.removeItem("ZHIYUANSTATUS");
        localStorage.removeItem("head_img");
        localStorage.removeItem("isVipStr");
        localStorage.removeItem("isNewUser");
        localStorage.removeItem("token");
        localStorage.removeItem("vipType");
        localStorage.removeItem("hasLogin");
        store.commit('user/LOGINSTATUS', true);
      } else {
        if (binding.expression) {
          binding.value()
        }
      }
    }
    el.onfocus = function (event) {
      event.stopPropagation();
      //监听点击事件，判断是否登录
      if (!store.state.user.token) {
        event.preventDefault();
        localStorage.removeItem("mobile");
        localStorage.removeItem("gkInforObj");
        localStorage.removeItem("ZHIYUANSTATUS");
        localStorage.removeItem("head_img");
        localStorage.removeItem("isVipStr");
        localStorage.removeItem("isNewUser");
        localStorage.removeItem("token");
        localStorage.removeItem("vipType");
        localStorage.removeItem("hasLogin");
        localStorage.removeItem("imitate_data");
        store.commit('user/LOGINSTATUS', true);
      } else {
        if (binding.expression) {
          binding.value()
        }
      }
    }
  }
});

router.beforeEach((to, from, next) => {
  if(to.fullPath === '/404') {
    return
  }
  if(to.path === '/schoolDetail' || to.path === '/sameScore' || to.path === '/toolsRank' || to.path === '/toolsAdmission') {
    store.commit('user/GETBATCH')
  }
  if(from.path == '/home' && to.path == '/home') {
  } else {
    const params = getQuery()
    if(params.token) {
      setToken(params.token)
      store.commit('user/SAVETOKEN', params.token)
    }
  }
  if (!store.state.user.token) {
      if (
          to.matched.length > 0 &&
          !to.matched.some(record => record.meta.auth)
      ) {
          // store.commit('user/LOGINSTATUS', false);
          next()
      } else {
        localStorage.removeItem("mobile");
        localStorage.removeItem("gkInforObj");
        localStorage.removeItem("ZHIYUANSTATUS");
        localStorage.removeItem("head_img");
        localStorage.removeItem("isVipStr");
        localStorage.removeItem("isNewUser");
        localStorage.removeItem("token");
        localStorage.removeItem("vipType");
        localStorage.removeItem("hasLogin");
        localStorage.removeItem("imitate_data");
        store.commit('user/LOGINSTATUS', true);
        router.push('/home')
      }
  }  else {
    if(to.path != '/zhiyuan') {
      localStorage.setItem("imitate_data", '')
    }
    next()
  }
})

router.afterEach( route => {
  window.scrollTo(0, 0);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
